import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import React from 'react';
import { EBLogoDesktop } from '../Icons/EBLogo';
import { NavItems, TrailingItems } from '../blocks/desktop';
import { NavbarProps } from '../types';
import styles from './DesktopNavbar.module.scss';

export const DesktopNavbar: React.FC<NavbarProps> = ({
  title,
  titleLink,
  navItems,
  ctas,
  className,
}) => {
  return (
    <div className={className}>
      <header role="banner" aria-label="Desktop Site header" className={styles.navbar_container}>
        <div className={styles.navbar_brand}>
          <a
            href="/"
            aria-label="Eventbrite Homepage"
            data-heap-id={formatHeapId([
              ANALYTICS_HEAP_IDS.DESKTOP,
              ANALYTICS_HEAP_IDS.NAVBAR,
              'brand-logo',
            ])}
          >
            <EBLogoDesktop />
          </a>
          <a
            href={titleLink}
            className={styles.title}
            aria-label="MLP Homepage"
            data-heap-id={formatHeapId([
              ANALYTICS_HEAP_IDS.DESKTOP,
              ANALYTICS_HEAP_IDS.NAVBAR,
              'mlp-logo',
            ])}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={title} alt="MLP Logo" loading="lazy" width="100%" height="16px" />
          </a>
        </div>
        {navItems && <NavItems navItems={navItems} />}
        <TrailingItems ctas={ctas} />
      </header>
    </div>
  );
};
